<div class="tw-mx-3 tw-my-5 tw-flex tw-items-center tw-justify-between">
  <ate-button-control class="tw-w-fit tw-min-w-0 tw-p-3" [queryParamsHandling]="'preserve'" [routerLink]="['..']" color="secondary"
    ><ate-icon name="chevron-left-v2"></ate-icon>
    Back
  </ate-button-control>

  <div class="tw-flex tw-items-center tw-gap-2">
    @if (!isMasquerading) {
      <ate-button-control class="tw-flex tw-w-fit tw-min-w-0 tw-gap-2 tw-p-3" [routerLink]="['/su/me/emails/compose', id]" color="secondary"
        ><ate-icon class="tw-h-4 tw-w-4" name="return-v2"></ate-icon>
        Reply
      </ate-button-control>
    }

    @if (!isLoading && !error && message && !hasLinkedEnquiry && !isNotLead && !isAutoNotALead) {
      <ate-button-control class="tw-flex tw-w-fit tw-min-w-0 tw-gap-2 tw-p-3" color="secondary" (click)="openNotLeadDialog()">
        <ate-icon class="tw-h-4 tw-w-4" name="close-v3"></ate-icon>
        Not a lead
      </ate-button-control>
    }
  </div>
</div>

<div
  class="tw-my-4 tw-overflow-hidden tw-border-b tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-slate-200 tw-bg-white md:tw-mx-3 md:tw-mx-[10px] md:tw-mx-[10px] md:tw-mx-[10px] md:tw-rounded-[5px] md:tw-border-l md:tw-border-r">
  @if (isLoading) {
    <div class="tw-p-6">
      <div class="tw-h-5 tw-w-1/2 tw-animate-pulse tw-rounded tw-bg-slate-200"></div>
      <div class="tw-mt-4 tw-space-y-2">
        <div class="tw-h-4 tw-w-full tw-animate-pulse tw-rounded tw-bg-slate-100"></div>
        <div class="tw-h-4 tw-w-5/6 tw-animate-pulse tw-rounded tw-bg-slate-100"></div>
        <div class="tw-h-4 tw-w-4/6 tw-animate-pulse tw-rounded tw-bg-slate-100"></div>
      </div>
    </div>
  }

  @if (!isLoading && error) {
    <div class="tw-p-6 tw-text-red-600">{{ error }}</div>
  }

  @if (!isLoading && !error && message) {
    <div class="tw-space-y-4 tw-pb-6">
      <div class="tw-flex tw-w-auto tw-justify-end tw-gap-2 tw-border-0 tw-border-b tw-border-solid tw-border-slate-300 tw-p-3">
        @if (linkedEnquiryUuid) {
          <ate-button-control class="tw-flex tw-w-fit tw-min-w-0 tw-gap-2 tw-p-3" color="secondary" (click)="navigateToLinkedEnquiry()">
            <ate-icon name="ate-eye"></ate-icon>
            View Enquiry
          </ate-button-control>
        } @else {
          <ate-button-control class="tw-flex tw-w-fit tw-min-w-0 tw-gap-2 tw-p-3 tw-text-[#804AF6]" color="secondary" (click)="convertEnquiry()">
            <ate-icon name="ate-chat-gpt"></ate-icon>
            Import Lead
          </ate-button-control>
        }
      </div>
      <div class="tw-px-6">
        <h3 class="tw-truncate tw-text-lg tw-font-semibold">{{ message.subject || '(no subject)' }}</h3>
        <p class="tw-text-sm tw-text-slate-500">From: {{ (message?.from?.email ?? messsage?.from?.name) || 'Unknown sender' }}</p>
        <p *ngIf="message?.labelIds?.includes('SENT')" class="tw-text-sm tw-text-slate-500">
          To: {{ (message?.to?.email ?? messsage?.to?.name) || 'Unknown sender' }}
        </p>
        @if (message.htmlBody) {
          <email-html-viewer [html]="message.htmlBody"></email-html-viewer>
        } @else {
          {{ message.textBody }}
        }
      </div>
    </div>
  }
  @if (!isLoading && !error && nonInlineAttachments.length > 0) {
    <div class="tw-p-6">
      <p>
        <strong>
          {{ nonInlineAttachments.length }}
          {{ nonInlineAttachments.length === 1 ? 'attachment' : 'attachments' }}
        </strong>
      </p>

      <div class="tw-grid tw-grid-cols-[repeat(auto-fit,minmax(200px,max-content))] tw-gap-4">
        @for (file of nonInlineAttachments; track file.attachmentId) {
          <div
            *ngIf="file.previewUrl"
            class="tw-group tw-relative tw-box-border tw-h-[100px] tw-w-[100px] tw-min-w-0 tw-cursor-pointer tw-overflow-hidden tw-rounded-md tw-border tw-border-solid tw-border-[#d7dee7] tw-font-normal md:tw-h-[200px] md:tw-w-[200px]"
            (click)="openImageLightbox(message, file.attachmentId)">
            <img [src]="file.previewUrl" class="tw-h-full tw-w-full tw-rounded tw-object-cover" />
            <div
              class="tw-absolute tw-left-0 tw-top-0 tw-box-border tw-flex tw-h-full tw-w-full tw-gap-2 tw-bg-black/50 tw-p-4 tw-text-sm tw-text-white group-hover:tw-flex md:tw-hidden">
              <div class="tw-pt-1"><ate-icon name="ate-image" class="tw-size-4"></ate-icon></div>
              <div class="tw-flex tw-h-full tw-flex-col tw-justify-between">
                <div>
                  <div class="tw-mb-1 tw-hidden tw-font-bold md:tw-block">{{ file.filename }}</div>
                  <div class="tw-text-xs">{{ formatSize(file.size) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div
            *ngIf="!file.previewUrl"
            (click)="downloadAttachment(message.id, file.attachmentId, file.filename)"
            class="tw-box-border tw-flex tw-h-[100px] tw-w-[100px] tw-min-w-0 tw-cursor-pointer tw-gap-2 tw-rounded-md tw-border tw-border-solid tw-border-[#d7dee7] tw-font-normal md:tw-h-[200px] md:tw-w-[200px]">
            <div class="tw-box-border tw-flex tw-gap-2 tw-p-4 tw-text-sm">
              <div class="tw-pt-1"><ate-icon name="ate-file" class="tw-size-4"></ate-icon></div>
              <div class="tw-flex tw-h-full tw-flex-col tw-justify-between">
                <div>
                  <div class="tw-mb-1 tw-hidden tw-font-bold md:tw-block">{{ file.filename }}</div>
                  <div class="tw-text-xs">{{ formatSize(file.size) }}</div>
                </div>
                <div class="tw-cursor-pointer">
                  <ate-icon name="download-secondary" class="tw-size-5"></ate-icon>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
@if (showNotLeadDialog) {
  <email-not-lead-dialog [fromEmail]="message?.from?.email" (action)="onNotLeadAction($event)" (closed)="showNotLeadDialog = false">
  </email-not-lead-dialog>
}

@if ((lightboxObservable$ | async)?.visible) {
  <app-lightbox open="true">
    @for (image of (lightboxObservable$ | async)?.lightboxImages; track $index) {
      <app-lightbox-image [url]="image"> </app-lightbox-image>
    }
  </app-lightbox>
}
